import { c as _c } from "react-compiler-runtime";
import { useMemo, useState } from 'react';
import { MIN_SIDEBAR_WIDTH } from '../../../constants/sidebar';
import debounce from '../../../utils/debounce';
const POPOVER_WIDTH = 380;
const INDICATOR_HEIGHT = 30;
export function useEmbeddedCommentHandlers(t0) {
  "use memo";

  const $ = _c(13);
  const {
    commentableArea,
    popoverPlacement,
    verticalPositioning,
    embeddedCommentWrapper,
    onUpdateCollaborationSidebarState
  } = t0;
  const [placement, setPlacement] = useState(popoverPlacement || "top");
  const [topOffset, setTopOffset] = useState(0);
  const [leftOffset, setLeftOffset] = useState(0);
  let t1;
  if ($[0] !== commentableArea || $[1] !== popoverPlacement || $[2] !== verticalPositioning) {
    t1 = debounce(() => {
      if (!(commentableArea instanceof HTMLElement)) {
        return;
      }
      let elementHeight = commentableArea.offsetHeight;
      if (commentableArea.children && commentableArea.children[0]) {
        const computedStyles = getComputedStyle(commentableArea.children[0]);
        elementHeight = elementHeight + parseInt(computedStyles.getPropertyValue("margin-bottom"), 10);
      }
      const defaultOffset = -INDICATOR_HEIGHT - 2;
      const horizontalTopOffset = elementHeight < 50 ? (elementHeight - INDICATOR_HEIGHT) / 2 : 10;
      setTopOffset(verticalPositioning ? defaultOffset : horizontalTopOffset);
      setLeftOffset(verticalPositioning ? 10 : defaultOffset);
      const {
        x
      } = commentableArea.getBoundingClientRect();
      if (x < POPOVER_WIDTH / 2 + MIN_SIDEBAR_WIDTH && !popoverPlacement) {
        setPlacement("top right");
      }
    }, 0);
    $[0] = commentableArea;
    $[1] = popoverPlacement;
    $[2] = verticalPositioning;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const updateIndicatorPlacement = t1;
  let t2;
  if ($[4] !== embeddedCommentWrapper || $[5] !== onUpdateCollaborationSidebarState) {
    t2 = debounce(() => {
      if (embeddedCommentWrapper) {
        const embeddedCommentRect = embeddedCommentWrapper.getBoundingClientRect();
        let top = Math.max(embeddedCommentRect.top, 0);
        let left = Math.max(embeddedCommentRect.left, 0);
        if (top > window.innerHeight) {
          top = window.innerHeight - embeddedCommentRect.height;
        }
        if (left > window.innerWidth) {
          left = window.innerWidth - embeddedCommentRect.width;
        }
        onUpdateCollaborationSidebarState({
          embeddedCommentCoordinates: {
            top,
            left,
            width: embeddedCommentRect.width,
            height: embeddedCommentRect.height
          }
        });
      }
    }, 50);
    $[4] = embeddedCommentWrapper;
    $[5] = onUpdateCollaborationSidebarState;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const updateEmbeddedCommentCoordinates = t2;
  let t3;
  if ($[7] !== leftOffset || $[8] !== placement || $[9] !== topOffset || $[10] !== updateEmbeddedCommentCoordinates || $[11] !== updateIndicatorPlacement) {
    t3 = {
      updateIndicatorPlacement,
      updateEmbeddedCommentCoordinates,
      placement,
      topOffset,
      leftOffset
    };
    $[7] = leftOffset;
    $[8] = placement;
    $[9] = topOffset;
    $[10] = updateEmbeddedCommentCoordinates;
    $[11] = updateIndicatorPlacement;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
}